import React from "react";
import "./Customer_Feedbacks_cards.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import Rating from "react-rating";

function Customer_Feedbacks_cards({
  nameText,
  imgSrc,
  dateText,
  productName,
  boldText,
  rating,
  images,
}) {
  const [showModal, setShowModal] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(0);

  const nextImage = () => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const openModal = (index) => {
    setActiveIndex(index);
    setShowModal(true);
  };

  const userInitial = nameText?.trim()?.charAt(0)?.toUpperCase() || "U";

  return (
    <>
      <section className="Customer_Feedbacks_cards">
        <div className="card_header">
          <div className="profile_holder">
            <div className="user_avatar">{userInitial}</div>
            <div className="user_info">
              <h6 className="user_name">{nameText}</h6>
              <Rating
                className="rating_icon"
                initialRating={rating}
                emptySymbol={<FontAwesomeIcon icon={farStar} color="#d6d6d6" />}
                fullSymbol={<FontAwesomeIcon icon={fasStar} color="#f4b400" />}
                fractions={2}
                readonly
              />
            </div>
          </div>

          <span className="review_date">{dateText}</span>
        </div>

        <div className="review_body">
          {productName && <p className="product_tag">{productName}</p>}
          <p className="review_text">{boldText}</p>
        </div>

        {images?.length > 0 && (
          <div className="review_images">
            {images?.map((feedback, index) => (
              <img
                key={index}
                src={process.env.REACT_APP_IMG_URL + feedback?.image}
                className="feedbackimg"
                alt="feedbackimg"
                onClick={() => openModal(index)}
              />
            ))}
          </div>
        )}

        {showModal && (
          <div className="image_modal_overlay">
            <div className="image_modal">
              <button className="close_btn" onClick={() => setShowModal(false)}>
                ✕
              </button>

              <button className="prev_btn" onClick={prevImage}>
                ◀
              </button>

              <img
                src={process.env.REACT_APP_IMG_URL + images[activeIndex]?.image}
                className="modal_image"
                alt="preview"
              />

              <button className="next_btn" onClick={nextImage}>
                ▶
              </button>

              <div className="image_counter">
                {activeIndex + 1} / {images.length}
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
}

export default Customer_Feedbacks_cards;
